/* eslint-disable class-methods-use-this */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import InputMask from 'react-input-mask';
import { isValid as isValidCnpj } from '@fnando/cnpj';
import exact from 'prop-types-exact';
import Button from '../../../common/button/Button';
import { showError } from '../../../common/A1Alert/A1Alert';

class FreeStreamingModalComponent extends Component {
    constructor() {
        super();

        this.state = {
            isOpen: false,
            company: '',
            tradeName: '',
            page: '',
            nameOwner: '',
            emailOwner: '',
            cnpj: '',
            telefone: '',
            band: '',
            frequency: '',
            power: '',
            state: '',
            city: '',
        };

        this._handleInputChange = this._handleInputChange.bind(this);
    }

    _toggleModal = () => {
        this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
    }

    _submitForm = (e) => {
        if (!this._validateInputs()) {
            return false;
        }

        e.preventDefault();

        const { company, tradeName, page, nameOwner, emailOwner, cnpj, telefone, band, frequency, power, state, city } = this.state;
        const data = {
            company,
            tradeName,
            cnpj,
            page,
            nameOwner,
            emailOwner,
            telefone,
            band,
            frequency,
            power,
            state,
            city,
        };

        return this.props.sendMessage(data);
    }

    _handleInputChange(event) {
        const target = event.target;
        const name = target.name;
        const value = target.value;

        this.setState({
            [name]: value,
        });
    }

    _validateInputs() {
        // Razão Social
        if (!this.state.company || this.state.company.length < 1 || this.state.company.length > 50) {
            showError('A razão social é um campo obrigatório');

            return false;
        }

        // Nome Fantasia
        if (!this.state.tradeName || this.state.tradeName.length < 1 || this.state.tradeName.length > 50) {
            showError('O nome fantasia é um campo obrigatório');

            return false;
        }

        // CNPJ (validated via @fnando/cpf plugin) // 78.627.051/0001-35 -> for testing
        if (this.state.cnpj && this.state.cnpj.length > 0 && !isValidCnpj(this.state.cnpj, true)) {
            showError('O CNPJ informado é inválido');

            return false;
        }

        // Site
        if (!this.state.page || this.state.page.length < 1 || this.state.page.length > 50) {
            showError('O site da empresa é um campo obrigatório');

            return false;
        }

        // Nome do Proprietário(can't be null, min 3 max 30 carateres)
        if (!this.state.nameOwner || this.state.nameOwner.length < 3 || this.state.nameOwner.length > 30) {
            showError('O nome do proprietário deve ter no mínimo 2 e no máximo 30 carateres');

            return false;
        }

        const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        // Email do proprietário (can't be null and needs to be valid and not more than 40 characters)
        if (!this.state.emailOwner || this.state.emailOwner.length <= 0 || this.state.emailOwner.match(emailRegex) == null || this.state.emailOwner.length > 40) {
            showError('O email é inválido');


            return false;
        }


        // Telefone (14 or 15 digits (with symbols))
        if (this.state.telefone && this.state.telefone.length > 0 && (this.state.telefone.length !== 14 && this.state.telefone.length !== 15)) {
            showError('O telefone informado é inválido');


            return false;
        }

        // Faixa de Operação
        if (!this.state.band) {
            showError('A faixa de Operação é um campo obrigatório');

            return false;
        }

        // Frequência
        if (!this.state.frequency) {
            showError('A frequência é um campo obrigatório');

            return false;
        }

        // Pocencia/Classe
        if (!this.state.power) {
            showError('A potência/classe é um campo obrigatório');

            return false;
        }

        // Estado
        if (!this.state.state || this.state.state.length < 1 || this.state.state.length > 50) {
            showError('O Estado é um campo obrigatório');

            return false;
        }

        // Cidade
        if (!this.state.city || this.state.city.length < 1 || this.state.city.length > 50) {
            showError('A cidade é um campo obrigatório');

            return false;
        }

        return true;
    }

    render() {
        const {
            company,
            tradeName,
            page,
            nameOwner,
            emailOwner,
            cnpj,
            telefone,
            band,
            frequency,
            power,
            state,
            city,
        } = this.state;
        const buttonDisabled = (this.props.submitting || this.props.submitted) ? 'buttonDisabled' : '';

        return ([
            <Button key="free-streaming-modal-button" className="freeStreamingModalButton" title="Saiba mais" onClick={this._toggleModal}>
                Solicitar acesso
            </Button>,
            <ReactModal
                isOpen={this.state.isOpen}
                onRequestClose={this._toggleModal}
                contentLabel="Entre em contato"
                className="freeStreamingModal"
                overlayClassName="overlayFreeStreamingModal"
                key="1"
                closeTimeoutMS={250}
            >
                <div className="contentFreeStreamingModal">
                    <div className="headerFreeStreamingModal">
                        <h1>Entre em contato</h1>
                    </div>
                    <form className="contactForm blocksFreeStreamingModal" onSubmit={(e) => e.preventDefault()}>

                        <div className="formBlock">
                            <div className="inputGroup">
                                <label htmlFor="company">
                                    Razão Social
                                    <span className="requiredField">*</span>
                                </label>
                                <input
                                    /* className={nameRed ? 'error nameInput' : 'nameInput'} */
                                    type="text"
                                    value={company}
                                    onChange={this._handleInputChange}
                                    name="company"
                                    id="company"
                                    autoCapitalize="words"
                                />
                            </div>
                            <div className="inputGroup">
                                <label htmlFor="tradeName">
                                    Nome Fantasia
                                    <span className="requiredField">*</span>
                                </label>
                                <input
                                    /* className={nameRed ? 'error nameInput' : 'nameInput'} */
                                    type="text"
                                    value={tradeName}
                                    onChange={this._handleInputChange}
                                    maxLength="50"
                                    name="tradeName"
                                    id="tradeName"
                                    autoCapitalize="words"
                                />
                            </div>
                            <div className="inputGroup">
                                <label htmlFor="cnpj">
                                    CNPJ
                                    <span className="requiredField">*</span>
                                </label>
                                <InputMask
                                    name="cnpj"
                                    id="cnpj"
                                    mask="99.999.999/9999-99"
                                    placeholder="00.000.000/0000-00"
                                    maskChar={null}
                                    type="text"
                                    value={cnpj}
                                    onChange={this._handleInputChange}
                                />
                            </div>
                            <div className="inputGroup">
                                <label htmlFor="page">
                                    Site
                                    <span className="requiredField">*</span>
                                </label>
                                <input
                                    /* className={nameRed ? 'error nameInput' : 'nameInput'} */
                                    type="text"
                                    value={page}
                                    onChange={this._handleInputChange}
                                    maxLength="50"
                                    name="page"
                                    id="page"
                                />
                            </div>
                            <div className="inputGroup">
                                <label htmlFor="nameOwner">
                                    Nome do proprietário
                                    <span className="requiredField">*</span>
                                </label>
                                <input
                                    /* className={nameRed ? 'error nameInput' : 'nameInput'} */
                                    name="nameOwner"
                                    id="nameOwner"
                                    type="text"
                                    value={nameOwner}
                                    onChange={this._handleInputChange}
                                    maxLength="30"
                                    autoComplete="name"
                                    autoCapitalize="words"
                                />
                            </div>
                            <div className="inputGroup">
                                <label htmlFor="emailOwner">
                                    E-mail
                                    <span className="requiredField">*</span>
                                </label>
                                <input
                                    /* className={emailRed ? 'error emailInput' : 'emailInput'} */
                                    name="emailOwner"
                                    id="emailOwner"
                                    type="text"
                                    autoComplete="email"
                                    value={emailOwner}
                                    onChange={this._handleInputChange}
                                    autoCapitalize="off"
                                    autoCorrect="off"
                                />
                            </div>
                        </div>
                        <div className="formBlock">
                            <div className="inputGroup">
                                <label htmlFor="telefone">
                                    Telefone de contato
                                    <span className="requiredField">*</span>
                                </label>
                                <InputMask
                                    name="telefone"
                                    id="telefone"
                                    mask="(99) 99999-9999"
                                    placeholder="(00) 00000-0000"
                                    maskChar={null}
                                    /* className={telRed ? 'error telInput' : 'telInput'} */
                                    type="tel"
                                    autoComplete="tel"
                                    value={telefone}
                                    onChange={this._handleInputChange}
                                />
                            </div>
                            <div className="inputGroup">
                                <label htmlFor="band">
                                    Faixa de Operação
                                    <span className="requiredField">*</span>
                                </label>
                                <input
                                    /* className={telRed ? 'error telInput' : 'telInput'} */
                                    name="band"
                                    id="band"
                                    type="text"
                                    value={band}
                                    onChange={this._handleInputChange}
                                    placeholder="FM"
                                />
                            </div>
                            <div className="inputGroup">
                                <label htmlFor="frequency">
                                    Frequência
                                    <span className="requiredField">*</span>
                                </label>
                                <InputMask
                                    name="frequency"
                                    id="frequency"
                                    placeholder="94.7"
                                    type="text"
                                    value={frequency}
                                    onChange={this._handleInputChange}
                                />
                            </div>
                            <div className="inputGroup">
                                <label htmlFor="power">
                                    Potência/Classe
                                    <span className="requiredField">*</span>
                                </label>
                                <input
                                    name="power"
                                    id="power"
                                    type="text"
                                    value={power}
                                    onChange={this._handleInputChange}
                                />
                            </div>
                            <div className="inputGroup">
                                <label htmlFor="city">
                                    Cidade
                                    <span className="requiredField">*</span>
                                </label>
                                <input
                                    name="city"
                                    id="city"
                                    type="text"
                                    value={city}
                                    onChange={this._handleInputChange}
                                    placeholder="São Paulo"
                                />
                            </div>
                            <div className="inputGroup">
                                <label htmlFor="state">
                                    Estado
                                    <span className="requiredField">*</span>
                                </label>
                                <input
                                    name="state"
                                    id="state"
                                    type="text"
                                    value={state}
                                    onChange={this._handleInputChange}
                                    placeholder="SP"
                                />
                            </div>
                            <div className="buttonsFreeStreamingModal">
                                <Button className="closeFreeStreamingModal" title="Fechar" onClick={this._toggleModal}>
                                    Fechar
                                </Button>
                                <Button className={`submitFreeStreamingModal ${buttonDisabled}`} title="Enviar" onClick={this._submitForm} disabled={!!buttonDisabled}>
                                    {
                                        this.props.submitting
                                            ? 'enviando ...'
                                            : this.props.submitted
                                                ? 'Enviado'
                                                : 'Enviar'
                                    }
                                </Button>
                            </div>
                        </div>
                    </form>
                </div>
            </ReactModal>,
        ]);
    }
}

FreeStreamingModalComponent.propTypes = exact({
    sendMessage: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    submitted: PropTypes.bool,
});

export default FreeStreamingModalComponent;
